import { useEffect, useContext } from 'react'
import { useDispatch, batch } from 'react-redux'
import MapContext from './MapContext'

import { lnglat2quadhash } from '../../quadkeys'

import { setInfoPanel, showMapPanel } from '../../slices/ui'
import { setProfilePin } from '../../slices/profile' 
import { setMapPin, setMapView } from '../../slices/map'

export const queryRenderedFeatures = (map, x, y, tollerance) => {
  const bbox = [
      [x - tollerance, y - tollerance],
      [x + tollerance, y + tollerance]
  ]
  return map.queryRenderedFeatures(bbox)
}

const InfoControl = (props) => {
  const map = useContext(MapContext)
  const dispatch = useDispatch()

  useEffect(() => {
    if (!map) return

    const clickHandler = (e) => {
      const { x, y } = e.point
      const features = queryRenderedFeatures(map, x, y, 5)
      const feature = features.filter(x => (x.source === 'features' || x.source === 'favorites'))[0]
      let step = features.filter(x => x.sourceLayer === 'step')[0]
      const waypoint = features.filter(x => x.sourceLayer === 'waypoint')[0]

      if (feature) {
        if (feature.properties.cluster){
          const source = map.getSource(feature.source)
          source.getClusterExpansionZoom(feature.properties.cluster_id, (error, zoom) =>{
            if (!error && zoom){
              batch(() => {
                dispatch(setMapView({ lnglat: e.lngLat, zoom: zoom }))
                dispatch(setInfoPanel(false))
              })
            }
          })
        } else {
          let payload = {
            type: feature.properties.type,
            id: feature.properties.id
          }
          batch(() => {
            dispatch(showMapPanel(true))
            dispatch(setInfoPanel(payload))
          })
        } 
        e.originalEvent.stopImmediatePropagation()
        return
      }


      if (!step && waypoint && waypoint.properties.type == 'waypoint'){
          step = queryRenderedFeatures(map, x, y, 400).filter(
                x => x.sourceLayer === 'step' && 
                x.properties.waypoint_quadhashs.split('-').indexOf(waypoint.properties.quadhash) !== -1
          )[0]
      }

      if (step) {
        const payload = {
          type: 'step',
          step_trail_id: step.properties.trail_id,
          step_id: step.properties.step_id
        }
        batch(() => {
          dispatch(showMapPanel(true))
          dispatch(setInfoPanel(payload))
        })
        e.originalEvent.stopImmediatePropagation()
        return
      }

      if (waypoint) {
        let payload
        const type = waypoint.properties.type
        switch (type) {
          case 'waypoint':
            payload = {
              type: 'waypoint',
              quadhash: waypoint.properties.quadhash,
            }
            break;
          case 'poi':
          case 'accommodation':
            payload = {
              type: type,
              id: waypoint.properties.id,
            }
            break;
          default:
            payload = null
        }

        batch(() => {
          dispatch(showMapPanel(!!payload))
          dispatch(setInfoPanel(payload))
        })
        e.originalEvent.stopImmediatePropagation()
        return
      }
      //const {lng, lat} = e.lngLat
      //console.log(lng, lat)
      //const quadhash = lnglat2quadhash(lat, lng)
      //const payload = {
              //type: 'waypoint',
              //quadhash: quadhash,
            //}
      //batch(() => {
          //dispatch(showMapPanel(!!payload))
          //dispatch(setInfoPanel(payload))
        //})
      //e.originalEvent.stopImmediatePropagation()
      //return

      dispatch(setInfoPanel(null));

    }

    map.on('click', clickHandler)

    return () => map && map.off('click', clickHandler)

  }, [map, dispatch])

  return null
}

export default InfoControl
